<template>
    <div class="cover-page">
        <div class="left-side">
            <div class="cover-solid">
                <div class="title-container">
                    <div class="my_face">
                    </div>
                    <h3 class="main-title">Hola, soy {{ name }}</h3>
                    <hr>
                </div>
                <div class="about-me">
                    <p v-for="(text, index) in paragraphs" :key="index">
                        {{ text }}
                    </p>
                </div>
            </div>
        </div>
        <div class="right-side">
            <div class="cover-image"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CoverPage',
        data: function() {
            return {
                name: 'Antonio Duprez',
                paragraphs: [
                    '¡Encantado de conocerte! Soy desarrollador fullstack, he trabajado con tecnologías como Angular,\n' +
                    'NodeJS, Ionic, Firebase, MongoDB, entre otras. Me gustaría seguir\n' +
                    'formándoome y conseguir llegar a mi máximo potencial junto a un grupo de\n' +
                    'compañeros con los que me sienta cómodo y podamos trabajar en equipo.',
                    'En este portfolio encontrarás algunos de mis trabajos más recientes, si tienes cualquier pregunta, ¡no dudes en contactarme!'
                ]
            };
        }
    }
</script>

<style scoped lang="scss">
    @import "../styles/_variables.scss";
    .cover-page {
        display: flex;
        background-color: $background-color;
    }
    .left-side, .right-side {
        width: 50%;
    }
    .cover-solid {
        height: 100vh;
        width: 100%;
        background-color: $background-color;
        opacity: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        padding: 35px;
    }
    .cover-image {
        height: 100vh;
        width: 100%;
        background-image: url("../assets/me.jpg");
        background-repeat: no-repeat;
        background-size: cover;
        background-position: 50% 50%;
        clip-path: polygon(20% 0, 100% 0%, 100% 100%, 0% 100%);
        opacity: 1;
    }
    .title-container {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .main-title {
        color: $title-color;
        font-size: 25px;
    }
    hr {
        width: 110px;
        background-color: $primary-color;
        margin: 15px;
    }
    .about-me {
        color: $font-color;
        p {
            margin: 30px 0;
        }
    }

    .my_face {
        display: none;
    }

    @media (max-width: $lg) {
        .left-side {
            width: 100%;
        }
        .right-side {
            width: 0;
        }
    }

    @media (max-width: $md) {
        .title-container {
            flex-direction: column;
        }
        hr {
            width: 100%;
        }
    }

    @media (max-width: $xs) {
        .title-container, .about-me {
            text-align: center;
        }
        .my_face {
            display: block;
            width: 115px;
            height: 115px;
            border-radius: 100%;
            background-image: url("../assets/my_face.jpg");
            background-repeat: no-repeat;
            background-size: cover;
        }
    }
</style>